import { render, staticRenderFns } from "./CardModal.vue?vue&type=template&id=11233914&scoped=true&"
import script from "./CardModal.vue?vue&type=script&lang=ts&"
export * from "./CardModal.vue?vue&type=script&lang=ts&"
import style0 from "./CardModal.vue?vue&type=style&index=0&id=11233914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11233914",
  null
  
)

export default component.exports